<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { Button, Logo, integer } from '@smatch/cassiopeia-web-components';

    /* EXPORTS --------------------------------------------------------------------------------- */

    export let total: number = 0;
    export let isPreview: boolean = false;

</script>

{#if isPreview}

    <div class = 's8-preview-banner pt-2 xs:pt-0'>
        <Logo />

        <div class = 'mt-px text-center w-full'>
            <span class = 'inline-block max-w-[520px] lg:max-w-full'>
                {#if total > 10}
                    Welcome! You are currently viewing 20 of the
                    { integer(total, false) } products in this deal!
                    <Button
                        url = '#authentication'
                        label = 'Register or Login'
                        size = 'xs'
                        color = 'dark'
                        css = 'mx-1 mt-1'
                    />
                    to see the full deal.
                {:else}
                    Welcome!
                        <Button
                            url = '#authentication'
                            label = 'Register or Login'
                            size = 'xs'
                            color = 'dark'
                            css = 'mx-1 mt-1'
                        />
                    to see the full deal.
                {/if}
            </span>
        </div>
    </div>

{/if}

<style lang="postcss">
    @keyframes moveBackground {
        0% {
            background-position: 0 0;
        }
        100% {
            background-position: 100% 0;
        }
    }

    div.s8-preview-banner {
        @apply flex flex-col xs:flex-row border-b border-primary-200;
        @apply text-sm fixed top-0 items-center z-30 w-full bg-primary-100 text-dark text-center gap-x-4 gap-y-2 px-4;
        @apply h-36 xxs:h-32 xs:h-28 sm:h-24 md:h-20 lg:h-16 leading-relaxed;

        --colorA: rgba(255, 255, 255, 0.1);
        --colorB: rgba(255, 255, 255, 0);

        background-image: linear-gradient(
            45deg,
            var(--colorA) 25%,
            var(--colorB) 25%,
            var(--colorB) 50%,
            var(--colorA) 50%,
            var(--colorA) 75%,
            var(--colorB) 75%,
            var(--colorB) 100%
        );
        background-size: 30px 30px;
        animation: moveBackground 90s linear infinite;
    }
</style>